import { render, staticRenderFns } from "./ContestWinnerComponent.vue?vue&type=template&id=34f8e07f"
import script from "./ContestWinnerComponent.vue?vue&type=script&lang=js"
export * from "./ContestWinnerComponent.vue?vue&type=script&lang=js"
import style0 from "./ContestWinnerComponent.vue?vue&type=style&index=0&id=34f8e07f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports